export default {
  tabbar1: "ホームページ",
  tabbar2: "シネマ",
  tabbar3: "側室を選ぶ",
  tabbar4: "投票する",
  tabbar5: "私の",
  login: "サインイン",
  userNamePlaceholder: "携帯電話番号を入力してください",
  passwordPlaceholder: "パスワードを入力してください",
  forgotPassword: "パスワードをお忘れですか？",
  noAccount: "アカウントをお持ちでないですか？",
  registerNow: "今すぐ登録",
  register: "届ける",
  inviteCodeePlaceholder: "招待コードを入力してください",
  consentAgreement: "私は口座開設規約の内容を理解し、同意します。取引条件",
  highEndZone: "ハイエンドゾーン",
  EnjoyTheUltimateLuxuryExperience: "究極の贅沢体験をお楽しみください",
  airborne: "飛行機",
  viewMoreData: "もっと見る",
  aboutCannonRecommend: "接続に関する推奨事項",
  current: "対す",
  peopleNowMatch: "人がオンラインでマッチングしています",
  accountMembership: "アクティブ化された",
  highEnd: "貴殿",
  authentication: "認証",
  videoAuthentication: "ビデオ認証",
  tollRange: "充電範囲",
  personHeight: "身長",
  bust: "胸囲",
  serviceCity: "都市に奉仕する",
  nationalAirborne: "全国各地で空輸",
  askHerOut: "彼女とデートしたい",
  uptodate: "最新の",
  play: "通る",
  reservation: "予約する",
  beautifulGirl: "アメリカン・ガール",
  people: "人々",
  requiredPromotion: "昇進に必要",
  integral: "マーク",
  rechargePoints: "補充する",
  redeemPoints: "償還",
  myActivityPoints: "私の活動ポイント",
  currencySymbol: "せきぶん",
  basicInformation: "基本情報",
  personalReports: "個人的な報告",
  loginPassword: "ログインロック",
  paymentPassword: "支払いパスワード",
  taskLog: "ミッションログ",
  noticeAnnouncement: "システム発表",
  onlineService: "顧客サービス",
  logOut: "サインアウト",
  residence: "住所",
  reservationNow: "今すぐ予約",
  photo: "写真",
  video: "ビデオ",
  personalProfile: "個人プロフィール",
  popularRecommendations: "トップ・ピック",
  switchWindows: "スイッチ",
  designatedTime: "ピリオド",
  votingResults: "投票結果",
  ISSUE: "シリアル番号",
  data: "抽選結果",
  big: "東京",
  small: "横浜",
  one: "大阪",
  two: "名古屋",
  currentSelectedNumber: "現在の選択",
  pointsPerOrder: "注文ごとのポイント",
  inTotal: "投票数",
  amountMoney: "金額",
  availablePoints: "利用可能ポイント",
  submitTo: "だす",
  artilleryEngagement: "デート活動",
  recharge: "リチャージ",
  payeeName: "受取人名",
  bankName: "銀行名",
  bankCardNumber: "口座番号",
  bankCardNumberPlaceholder: "銀行カード番号を入力してください。",
  branchName: "支店名",
  branchNumber: "支店番号",
  selectBank: "銀行を選択してください",
  nameOfPayer: "支払者名",
  uploadPaymentVoucher: "送金伝票のアップロード",
  rechargePrompt:
    "操作を繰り返さないでください。 長期間未入金の場合は、お客様にご連絡ください。",
  confirmRecharge: "上乗せの確認",
  exchangeRecords: "償還記録",
  whole: "フル",
  limitDescription: "出場枠の説明",
  singleTransactionLimit: "シングルストロークリミット",
  minimum: "最低",
  highest: "最高",
  withdrawalFrequency: "引き出し数",
  dailyHighest: "1日最大",
  order: "副",
  freeOfHandlingFees: "(500回まで手数料無料）",
  receiptTime: "到着時間：一般的な到着時間は約5分、口座まで最速2分",
  residualIntegral: "残りポイント",
  individual: "個々",
  redeemPointsNow: "すぐに返金",
  headSculpture: "アバター",
  fullName: "カタカナ",
  gender: "男女の区別",
  male: "男性",
  female: "女性",
  unknown: "未開拓",
  bankCardInformation: "銀行カード情報",
  have: "そこには",
  notHave: "ない",
  modifyRealName: "本名を変更する",
  save: "セーブ",
  fullNamePlaceholder: "本名を入力してください",
  modifyRealNameRemake:
    "口座の安全性を確保するため、本名は紐付けされた銀行カードの名義と同じである必要がある。",
  modifyGender: "性別の変更",
  cardNumber: "銀行名",
  cardName: "ユーザー名",
  cardID: "口座番号",
  addBankCard: "銀行カードの追加",
  addBankCardRemake:
    "注意：大手商業銀行にお問い合わせください。 変更が必要な場合は、オンラインでカスタマーサービスにご連絡ください。",
  payCardInfoPlaceholder: "カード情報を入力してください。",
  addBankCardPrompt:
    "ユーザーの皆様へ、資金の安全性を確保するため、本名をリンクし、出金パスワードを設定してください。 お名前と口座名義が一致しない場合、資金を引き出すことができません。",
  personalReport: "個別声明",
  profitPoints: "収益ポイント",
  profiCalculationFormula: "利益計算式：勝ち点-ミッション・ポイント",
  taskPoints: "ミッション・ポイント",
  withdrawalPoints: "退会ポイント",
  winningPoints: "勝点",
  changeLoginPassword: "ログインパスワードの変更",
  oldPwd: "旧パスワード",
  oldPwdPlaceholder: "旧パスワードを入力してください",
  newPwd: "新しいパスワード",
  newPwdPlaceholder: "新しいパスワードを入力してください。",
  againOldPwdPlaceholder: "新しいパスワードをもう一度入力してください。",
  taskRecord: "委任事項の記録",
  emptyData: "データは空です",
  betPoints: "ベッティング・ポイント",
  orderTime: "注文の時期",
  settlementTime: "決済時間",
  refreshSuccessful: "リフレッシュ成功",
  invalidFunction: "この機能は無効です",
  appointmentSuccessful: "予約は成功した",
  completeActivationTask: "アクティベーション・タスクを完了してください。",
  checkAgreement: "以下の口座開設同意書にチェックを入れてください。",
  integralError: "ポイントエラー",
  selectNumber: "番号を選んでください",
  fillInPoints: "ポイントを記入してください",
  insufficientPoints:
    "ポイント不足の場合は、カスタマーサービスまでご連絡ください",
  contactCollect: "この割り当てを受けるには、管理者に連絡してください",
  successfulLotteryDraw: "開幕に成功、期間ナンバー：",
  notSet: "がらがら",
  contactService:
    "パスワードの変更が必要な場合は、カスタマーサービスまでご連絡ください。",
  completeTask:
    "タスクオーダーに必要事項を記入し、次のように入力してください。",
  setUpBankCard: "銀行カードを設定してください",
  accountOffline: "オフラインアカウント",
  fileTooLarge: "ファイルが大きすぎる",
  formatRule: "正しい形式で画像をアップロードしてください。",
  uploadSuccessful: "アップロード成功",
  amountError: "金銭的誤差",
  setNameToBindBankCard:
    "あなたの名前を設定し、銀行カードをバインドしてください。",
  setWithdrawalPasswordToBindBankCard:
    "出金パスワードを設定し、銀行カードをバインドしてください。",
  passwordInconsistency: "一貫性のないパスワード",
  complete: "必要事項をご記入ください。",
  changWithdrawalPasswordContactSustomerService:
    "引き出しパスワードが設定されています。変更が必要な場合は、カスタマーサービスまでご連絡ください。",
  activateWatchVideo: "アクティベーションを行い、ビデオをご覧ください。",
  rechargeWatchVideo: "トップアップしてビデオをご覧ください",
  pour: "モノ",
  taskList: "タスクリスト",
  clearOrder: "クリア・オーダー",
  confirmSub: "提出の確認",
  switchLanguage: "言語切り替え",
  illustrate: "指示",
  submissionTime: "提出時期",
  auditTime: "監査時間",
  payPwdPl: "支払いパスワードを入力してください",
  enterPayPwdPl: "支払いパスワードを再入力してください",
  setPayPwd: "支払パスワードの設定",
  yse: "はい",
  loadingtext: "読み込み中...",
  finishedtext: "もうデータはありません",
  pullingtext: "プルダウンして更新します",
  loosingtext: "放してリフレッシュ",
  bettingContent: "ご注文内容",
  xinyufen: "評判のポイント",
  applyMembershipCard: "会員カードを申請する",
  xqaltit: "幸せの物語",
  LastUpdated: "最終更新日",
  tpzx: "投票センター",
  grzx: "マイページ",
  ljmfks: "今すぐ無料ではじめる",
  rgnyzh: "アカウントをお持ちの方",
  bfwbxsbsyxkf: "18歳未満の方はご利用いただけません。",
  aqkkdppfw: "安心安全なマッチングサービスの形「IMS認証」",
  ckgdxqal: "その他のマッチメイキング事例を見る",
  syqlaqkkdyy: "安心安全に使える理由",
  syqlaqkkdjtnr:
    "真剣な交際を望んでいるご利用者様が安心・安全にご利用いただくために、さまざまな取り組みを行っています。",
  safetit011: "24時間365日の",
  safetit012: "厳重な監視体制",
  safecon01:
    "テクノロジーと有人による目視の常時監視体制によりすべての利用者に安心・安全なサービスを提供しています。",
  safetit02: "本人確認が必須です",
  safecon02:
    "メッセージのやり取りには、顔写真付き公的証明書での本人確認が必須です。",
  safetit03: "実名は表示されません",
  safecon03:
    "プロフィールはイニシャル・ニックネームで表示されるため、実名が表示されることはありません。",
  safetit041: "悪質ユーザーは",
  safetit042: "強制退会されます",
  safecon04:
    "利用者からの違反報告のほか、AIを活用し不正・悪質ユーザーの検知を実施。警告および強制退会等、厳正な対応を行っています。",
  safetit051: "SNSには",
  safetit052: "投稿されません",
  safecon05:
    "LINEなどのSNSで会員登録を行った場合でも、投稿が行われることはありません。",
  safetit061: "各種認証を",
  safetit062: "取得しています",
  safecon06:
    "個人情報セキュリティマーク「TRUSTe認証」や適正な運営が行われているマッチング事業者の証「IMS認証マーク」を取得しています。",
  cwwt: "よくある質問",
  q1: "無料でサービスが利用できますか？",
  a1:
    "無料で登録、マッチングが可能です。無料会員の場合、男性はメッセージ1通目の送信まで、女性はメッセージの送受信が可能です。",
  q2: "不特定多数の方から自分のプロフィールが見えない状態で利用できますか",
  a2:
    "自分が「いいね！」した人、マッチングした人にだけ、自分のプロフィールが見えるようになる「非公開」設定を推奨します。この機能は全会員無料でご利用いただけます。",
  q3: "トラブルに巻き込まれないか不安です",
  a3:
    "では安心・安全にご利用いただくための情報を集約した「セーフティセンター」を設置しています。ご活用いただき、不安が残るようでしたら「カスタマーサポート」の窓口までお問い合わせください。",
  cbdjmtbd: "は数多くのメディアで紹介されています",
  gzhyhhjzc: "様々な結婚・婚活支援",
  wzzcyzgxm: "プロジェクトに参画しています",
  xm1:
    "日本の結婚や婚活を応援するため、様々な企業の協賛により設立された一般社団法人です。",
  xm2:
    "結婚を希望する方がその希望を実現できるよう、神奈川県が取り組んでいる結婚支援事業です。",
  xm3:
    "少子化対策を目的に、若者の出会いを後押しするため、秋田県横手市が取り組む「若者出会い応援」。",
  zxyhfwzch: "インターネット異性紹介事業 届出済み：渋谷25-001649",
  slfh: "（受理番号：30230025-004）",
  sm: "ご声明",
};
